var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumPadDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.984,
    height: 41,
    viewBox: "0 0 52.984 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28684",
    "data-name": "Group 28684",
    transform: "translate(-60 -286.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-backspace",
    "data-name": "Icon ionic-ios-backspace",
    d: "M46.736,6.75H26.118c-5.836,0-9.147,4.336-12.746,7.935s-9.01,9.335-9.01,9.335a3.93,3.93,0,0,0-.987,2.612,4.012,4.012,0,0,0,.987,2.624s4.286,4.7,9.01,9.435,7.085,8.06,12.746,8.06H46.736a8.775,8.775,0,0,0,8.622-8.872V15.372A8.56,8.56,0,0,0,46.736,6.75Z",
    transform: "translate(57.125 280.25)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26029",
    "data-name": "Group 26029",
    transform: "translate(347.607 106.3) rotate(135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26028",
    "data-name": "Group 26028",
    transform: "translate(314.415 30.624)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x2: 16,
    transform: "translate(8 0) rotate(90)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 16,
    transform: "translate(0 8)",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumPadDel);
export default __webpack_public_path__ + "static/media/num-pad-del.f60fff5e1e9f2bc986794c9754d34289.svg";
export { ForwardRef as ReactComponent };